/* eslint-disable no-unused-expressions */
import React from 'react'
import PropTypes from 'prop-types'
import { Select, MenuItem, Box, Button, Typography } from '@material-ui/core'
import moment from 'moment'

import './DashboardComponent.scss'
import { DISTRIBUTION, MEDIA_COMPANY, STREAMING } from '../../constants/sov'

export default class SOVNetworksHeader extends React.Component {
  static propTypes = {
    homepage: PropTypes.object,
    history: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    selectedCategory: PropTypes.string,
    setSelectedCategory: PropTypes.func,
    fetchSOVNetworks: PropTypes.func,
    fetchSOVCotentRank: PropTypes.func,
    fetchSOVCotentRankByScore: PropTypes.func,
    setSelectedMetricDate: PropTypes.func
  }

  handleCategorySelect = (e) => {
    const category = e.target.value
    this.props.setSelectedCategory(category)
    const categoryDate = moment(new Date()).format('YYYY-MM-DD')
    this.props.fetchSOVNetworks(category, categoryDate)
    const date = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD') //Latest date, current date minus one
    this.props.fetchSOVCotentRank(category, date, true)
    this.props.fetchSOVCotentRankByScore(category, date, false)
    this.props.setSelectedMetricDate(date)
    this.props.history.push(`/insights/dashboard/${category}`)
  }

  render () {
    const categories = this.props.homepage && this.props.homepage.details && this.props.homepage.details.sov_networks && this.props.homepage.details.sov_networks.length > 0 ? this.props.homepage.details.sov_networks.map(n => n.name) : []
    return (
      <Box className='headWrap'>
        <ul className="hFirstRow straemUl">
          <li className="imgHolder dashHolder">
            <img alt="" src="/static/images/sovDefault.svg" className="imgThumb dashboardIcon" />
          </li>
          { this.props.shortcut &&
            <li>
              <Box pl={1} className='shortcutTitle'>
                <Typography>
                  <span className="title">{this.props.selectedCategory}</span>
                </Typography>
              </Box>
            </li>
          }
          { (!this.props.shortcut && categories.length > 0) &&
            <li>
              <Select
                labelId="select-filled-label"
                id="select-filled"
                className='streamSelect'
                value={this.props.selectedCategory}
                onChange={(e) => this.handleCategorySelect(e)}
              >
                { categories.indexOf(STREAMING) > -1 &&
                  <MenuItem value={STREAMING} className='optionBox'>
                    <Box className="d-flex flex-column pt-1">
                      <span className="optionLabel">Streaming Dashboard</span>
                    </Box>
                  </MenuItem>
                }
                { categories.indexOf(DISTRIBUTION) > -1 &&
                  <MenuItem value={DISTRIBUTION} className='optionBox'>
                    <Box className="d-flex flex-column pt-1">
                      <span className="optionLabel">Distribution Dashboard</span>
                    </Box>
                  </MenuItem>
                 }
                { categories.indexOf(MEDIA_COMPANY) > -1 &&
                  <MenuItem value={MEDIA_COMPANY} className='optionBox'>
                    <Box className="d-flex flex-column pt-1">
                      <span className="optionLabel">Media Company Dashboard</span>
                    </Box>
                  </MenuItem>
                }
              </Select>
            </li>
          }
        </ul>
        <Button className='dayBtn'>Last 30 days</Button>
      </Box>
    )
  }
}